module.exports = __webpack_public_path__ + "4021f0f7b78da61281dcb6c465cd131c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/Purple1.jpg
// module id = 11
// module chunks = 0